module.exports = __webpack_public_path__ + "img/JeffBrutlag.aaa61a31.jpg";